<div [class]="styleClass" [innerHTML]="html | keepHtml"></div>